var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "classnames", "../GuideProgram/GuideProgram", "../../UI/Icon/ArrowDown", "../GuideProgram/GuideProgram.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("classnames"), require("../GuideProgram/GuideProgram"), require("../../UI/Icon/ArrowDown"), require("../GuideProgram/GuideProgram.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.classnames, global.GuideProgram, global.ArrowDown, global.GuideProgram);
    global.PreviousPrograms = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _classnames, _GuideProgram, _ArrowDown, _GuideProgram2) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _GuideProgram = _interopRequireDefault(_GuideProgram);
  _ArrowDown = _interopRequireDefault(_ArrowDown);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var PreviousPrograms = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(PreviousPrograms, _Component);

    var _super = _createSuper(PreviousPrograms);

    function PreviousPrograms(props) {
      var _this;

      (0, _classCallCheck2.default)(this, PreviousPrograms);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSeePreviousClick", function () {
        _this.setState(function (prevState) {
          return {
            isClosed: !prevState.isClosed,
            openedByKey: false
          };
        }, function () {
          _this.focusFirstProgram();
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSeePreviousKeyPress", function () {
        _this.setState(function (prevState) {
          return {
            isClosed: !prevState.isClosed,
            openedByKey: true
          };
        }, function () {
          _this.focusFirstProgram();
        });
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focusFirstProgram", function () {
        var firstProgram = _this.domElement.querySelector("".concat(_GuideProgram2.StyledProgram, " a"));

        firstProgram.focus();
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "init", function (domElement) {
        _this.domElement = domElement;
      });
      _this.state = {
        isClosed: true,
        openedByKey: false
      };
      return _this;
    }

    (0, _createClass2.default)(PreviousPrograms, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            programs = _this$props.programs,
            seePrevious = _this$props.seePrevious;
        var _this$state = this.state,
            isClosed = _this$state.isClosed,
            openedByKey = _this$state.openedByKey;
        return programs.length && /*#__PURE__*/_react.default.createElement("div", {
          className: "previous-programs"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('program-timeline', {
            'program-timeline--open': !isClosed
          }),
          ref: this.init
        }, programs.map(function (program) {
          return /*#__PURE__*/_react.default.createElement(_GuideProgram.default, (0, _extends2.default)({
            key: program.id
          }, program, {
            mouseFocus: !openedByKey,
            hidden: isClosed,
            tabIndex: isClosed ? -1 : 0
          }));
        })), /*#__PURE__*/_react.default.createElement("button", {
          className: (0, _classnames.default)('previous-programs__button', {
            hide: !isClosed
          }),
          onMouseUp: this.onSeePreviousClick,
          onKeyPress: this.onSeePreviousKeyPress
        }, seePrevious, /*#__PURE__*/_react.default.createElement(_ArrowDown.default, {
          size: "xsmall",
          className: (0, _classnames.default)('previous-programs__icon', {
            'is-closed': isClosed
          })
        }))) || null;
      }
    }]);
    return PreviousPrograms;
  }(_react.Component);

  PreviousPrograms.propTypes = {
    programs: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
    seePrevious: _propTypes.default.string
  };
  PreviousPrograms.defaultProps = {
    programs: [],
    seePrevious: 'See previous programs'
  };
  var _default = PreviousPrograms;
  _exports.default = _default;
});